export default {
	// normal

	social: {
		phoneOrEmailIsInCorrect: 'Phone or email is incorrect',
		maximumLength: 'Maximum {field} length is {number}',
	},
};
